import type { IConfigDeductionSlaConfigRepository } from "@src/domain/repositories/config";
import type { UpdateConfigDeductionSlaConfigDTO } from "@src/domain/dto/config";

export class UpdateConfigDeductionSlaConfigUseCase {
  private readonly repository: IConfigDeductionSlaConfigRepository;

  constructor(repository: IConfigDeductionSlaConfigRepository) {
    this.repository = repository;
  }

  execute(params: UpdateConfigDeductionSlaConfigDTO) {
    return this.repository.updateDeductionSlaConfig(params);
  }
}
